import Request from './request';

async function fetch(data) {
    return Request('get', "api/last-order-prices", data);
}

export default {
    fetch,
};